import { render, staticRenderFns } from "./CfdisImportTable.vue?vue&type=template&id=2cd7baa3"
import script from "./CfdisImportTable.vue?vue&type=script&lang=js"
export * from "./CfdisImportTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports